import React, { useState, useEffect } from "react";
import api from "../../../../Axios/api";
import MaterialTable from "material-table";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";

import {
  Link,
  Grid,
  Paper,
  Modal,
  TextField,
  Container,
  Typography,
  Select,
  MenuItem,
  Button,
  LinearProgress,
  Chip,
  FormControlLabel,
  Switch,
} from "@material-ui/core";

import CSVReader from "react-csv-reader";
import { useUserContext } from "../../../../context/UserContext";

import Pal from "../../../../themes/palette";
import useStyles from "./styles";
import DeleteProduct from "../../../FormDialog/DeleteProduct";
import ImgNotAvailable from "../../../../assets/images/imgNotAvailable.jpg";

export default function ViewProductsOfStore() {
  const classes = useStyles();
  const { store } = useUserContext();
  const token = store.data.token;

  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };
  const handerChangeStatus = (id) => async (e) => {
    let newStatus = e.target.value;
    const newComplaintsList = details.map((el) =>
      el._id === id ? { ...el, isVisibilityEnabled: newStatus === "true" } : el
    );

    console.log(newComplaintsList);

    await api
      .patch(
        `/superAdmin/product/${id}`,
        { isVisibilityEnabled: newStatus },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Visibility Status has been Changed!",
          open: true,
        });
        setDetails(newComplaintsList);
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "ERROR: Something went Wrong!",
          open: true,
        });
      });
  };

  const [details, setDetails] = useState([]);

  const columns = [
    {
      title: "ID",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
    },
    {
      title: "Image",
      field: "images",
      render: ({ images }) => (
        <img
          src={images.length > 0 ? images[0] : ImgNotAvailable}
          alt="ProductImage"
          style={{ width: 40, height: 40, borderRadius: "50%" }}
        />
      ),
      hidden: false,
      export: false,
    },
    { title: "Name", field: "name", hidden: false, export: true },
    {
      title: "description",
      field: "description",
      hidden: true,
      export: true,
    },
    {
      title: "Store Name",
      field: "storeName",
      hidden: false,
      export: true,
    },
    {
      title: "Vendor Name",
      field: "vendorCompanyName",
      hidden: false,
      export: true,
    },
    { title: "Category", field: "category", hidden: false, export: true },
    {
      title: "purchasePrice",
      field: "purchasePrice",
      hidden: true,
      export: true,
    },
    {
      title: "SalePrice",
      field: "salePrice",
      render: ({ salePrice }) => <div>{"Rs." + salePrice}</div>,
      hidden: false,
      export: true,
    },
    {
      title: "State",
      field: "state",
      hidden: false,
      export: true,
    },
    {
      title: "StockAvailable",
      field: "stockAvailable",
      hidden: false,
      export: true,
    },
    {
      title: "discountPercentage",
      field: "discountPercentage",
      hidden: true,
      export: true,
    },
    { title: "Warranty", field: "warranty", hidden: false, export: true },
    {
      title: "Colors",
      field: "colors",
      render: ({ colors }) => <div>{colors[0]}</div>,
      hidden: true,
      export: false,
    },
    {
      title: "Status",
      field: "isVisibilityEnabled",
      align: "center",
      render: ({ isVisibilityEnabled }) => (
        <div
          style={{
            height: 30,
            width: 100,
            display: "flex",
            justifyContent: "right",
            alignItems: "center",
            background:
              isVisibilityEnabled === true
                ? "rgba(112, 224, 0, 0.7)"
                : "rgba(231, 76, 60, 0.7)",

            color: "#262626",
            borderRadius: 4,
          }}
        >
          <div
            style={{
              background:
                isVisibilityEnabled === true
                  ? "rgba(112, 224, 0, 0.7)"
                  : "rgba(231, 76, 60, 0.7)",

              width: 15,
              height: 15,
              borderRadius: 8,
              marginRight: 5,
              marginLeft: 5,
            }}
          ></div>
          {isVisibilityEnabled === true ? "Enabled" : "Disabled"}
        </div>
      ),
    },
    {
      field: "",
      title: "Actions",
      align: "center",
      render: (rowData) => (
        <div>
          <Select
            id="status"
            style={{ marginTop: 8 }}
            defaultValue={"DEFAULT"}
            onChange={handerChangeStatus(rowData._id)}
          >
            <MenuItem value="DEFAULT" disabled>
              Status
            </MenuItem>
            <MenuItem value="true">Enable</MenuItem>
            <MenuItem value="false">Disable</MenuItem>
          </Select>
        </div>
      ),
      export: false,
    },
    {
      title: "manufactureDate",
      field: "manufactureDate",
      hidden: true,
      export: true,
    },
    {
      title: "shippingCost",
      field: "shippingCost",
      hidden: true,
      export: true,
    },
    {
      title: "dimensions",
      field: "dimensions",
      hidden: true,
      export: true,
    },
    {
      title: "weight",
      field: "weight",
      hidden: true,
      export: true,
    },
  ];

  // category list retrive from DB
  const [productCategories, setProductCategories] = useState([]);
  const [productSubCategories, setProductSubCategories] = useState([]);
  const [productBrand, setProductBrand] = useState([]);
  const [productDetails, setProductDetails] = useState({
    name: "test",
    description: "test",
    category: "",
    subCategory: "",
    brand: "",
    manufactureDate: "11/06/2003",
    purchasePrice: "1000",
    salePrice: "1000",
    state: "New",
    shippingCost: "20",
    images: [],
    discountPercentage: 10,
    discountPrice: 0,
    stockAvailable: 0,
    dimensions: "",
    isOnSale: false,
    warranty: "",
    weight: "",
  });
  const [colors, setColors] = useState([]);

  const handlerColor = () => (e) => {
    var newColor = e.target.value;

    const found = colors.some((el) => el === newColor);
    if (!found) {
      setColors([...colors, e.target.value]);
    }
  };

  const handleDeleteColor = (el) => () => {
    setColors((colors) => colors.filter((color, index) => index !== el));
  };

  // updating BankDetails usestate
  const handleProductDetails = (input) => (e) => {
    setProductDetails({ ...productDetails, [input]: e.target.value });
  };

  const HanderdiscountSwitch = (e) => {
    setProductDetails({ ...productDetails, isOnSale: e.target.checked });
  };

  const handlerDiscount = (input) => (e) => {
    const discount = e.target.value;

    var discountPrice =
      productDetails.salePrice - productDetails.salePrice * (discount / 100);

    setProductDetails({
      ...productDetails,
      [input]: e.target.value,
      discountPrice,
    });

    console.log(productDetails);
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const fileHandler = async (event) => {
    let prevImages = productDetails.images;
    let files = event.target.files;
    let temp = [];

    for (let i = 0; i < files.length; i++) {
      var file64 = await toBase64(files[i]);
      temp.push(file64);
    }

    if (prevImages.length > 0) {
      setProductDetails({
        ...productDetails,
        images: [...prevImages, ...temp],
      });
    } else {
      setProductDetails({
        ...productDetails,
        images: temp,
      });
    }
  };

  const handlerDeletePImage = (index) => {
    const pImages = productDetails.images.filter(
      (el, eindex) => eindex !== index
    );

    setProductDetails({
      ...productDetails,
      images: pImages,
    });
  };

  const editProductHandler = (e) => {
    e.preventDefault();

    api
      .patch(
        `/superAdmin/product/${productDetails._id}`,
        {
          ...productDetails,
          colors,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        const newDetails = details.map((prod) =>
          prod._id === productDetails._id ? productDetails : prod
        );
        setDetails(newDetails);
        handleClose();
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Product has been Updated!",
          open: true,
        });
      })
      .catch(() => {
        handleClose();
        setSnackBar({
          ...snackBarstate,
          message: "ERROR: Something is not working properly!",
          type: "error",
          open: true,
        });
      });
  };

  // Edit Product Modal Settings here
  const [modalOpen, setModelOpen] = useState(false);
  const handleOpen = () => {
    setModelOpen(true);
  };
  const handleClose = () => {
    setModelOpen(false);
  };

  // Import Products List
  const [IPdata, setIPdata] = useState([]);

  // Import Products Modal
  const [ipmodalOpen, setIpmodalOpen] = useState(false);
  const openIPmodal = () => {
    setIpmodalOpen(true);
  };
  const closeIPmodal = () => {
    setIpmodalOpen(false);

    // reseting all form values
    setProgressCSV("determinate");
    setProgressCSV(0);
    setSelectedFile("");
    setIPdata([]);
  };

  // Delete Product Dialog
  const [isDeletingProduct, setIsDeletingProduct] = useState(false);

  // show delete Account Dialog
  const handlerAccountDelete = () => {
    setIsDeletingProduct(true);
  };
  // Delete Account Handler
  const confirmedDelete = () => {
    const productId = productDetails._id;

    // api to delete product
    api
      .delete(`/superAdmin/product/${productId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // Removing deleted Product from details array
        const newDetails = details.filter((prod) => prod._id !== productId);
        setDetails(newDetails);
        setIsDeletingProduct(false);
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Product has been deleted!",
          open: true,
        });
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "ERROR: Something went wrong!",
          open: true,
        });
      });
  };

  // ProgressBar variant
  const [progressCSV, setProgressCSV] = useState("determinate");
  const [progressValue, setProgressValue] = useState(0);
  const [selectedFile, setSelectedFile] = useState();

  const handleFileLoaded = (data, fileInfo) => {
    setSelectedFile(fileInfo.name);
    setProgressCSV("indeterminate");

    setTimeout(() => {
      setProgressValue(100);
      setProgressCSV("determinate");
    }, 1000);

    setIPdata(data);
  };

  const handeStartImport = async () => {
    try {
      var hasError = false;
      for (let i = 0; i < IPdata.length; i++) {
        await api
          .post("/superAdmin/product/", IPdata[i], {
            headers: { Authorization: `Bearer ${token}` },
          })
          // eslint-disable-next-line
          .catch(() => {
            hasError = true;
            setSnackBar({
              ...snackBarstate,
              type: "error",
              message: "Datafile contains wrong format!",
              open: true,
            });
          });
      }
      if (hasError === false) {
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "Products have been added successfully!",
          open: true,
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      setSnackBar({
        ...snackBarstate,
        type: "error",
        message: "ERROR: System is not responsind at the moment!",
        open: true,
      });
    }
  };

  // parse config
  const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    transformHeader: (header) =>
      header.charAt(0).toLowerCase().concat(header.slice(1)),

    //header.charAt(0).toLowerCase().concat(header.slice(1)),
  };

  const retrivingAllProducts = async () => {
    await api
      .get("/superAdmin/products", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log("products are ", res.data.data.products);
        setDetails(res.data.data.products);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  // Get Categories and Sub Categories from API
  const getAllCategory = async () => {
    // Parent Category
    api
      .get("/superAdmin/product/categories/view", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const categoryList = res.data.data.categories;
        setProductCategories(categoryList);
      })
      .catch((error) => console.log("Error: " + error));
  };

  const getSubCategory = async () => {
    if (productDetails.category !== "") {
      await api
        .get(`/superAdmin/subCategories/${productDetails.category}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          let categoryList = res.data.data.categories;
          let subCat = categoryList.map((el) => el.subCategory);
          let brands = categoryList.map((el) => el.brands);
          setProductSubCategories(subCat[0]);
          setProductBrand(brands[0]);
        })
        .catch((error) => console.log("Error: " + error));
    }
  };

  useEffect(() => {
    // Retriving List of Products from API
    retrivingAllProducts();

    // Retriving List of Categories from API
    getAllCategory();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getSubCategory();
    // eslint-disable-next-line
  }, [productDetails.category]);

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} sm={12} md={12} lg={8}>
        <Button variant="contained" color="primary">
          <Link href="/admin/view-products" style={{ color: "white" }}>
            Back
          </Link>
        </Button>
      </Grid>

      <Grid item xs={12} sm={12} md={11} component={Paper}>
        <MaterialTable
          style={{ width: "100%" }}
          title="All Products Of Store"
          data={details}
          columns={columns}
          actions={[
            (rowData) => ({
              icon: () => <EditIcon />,
              tooltip: "Edit",
              onClick: (event, rowData) => {
                setProductDetails(rowData);
                setColors(rowData.colors);
                handleOpen();
              },
            }),
            (rowData) => ({
              icon: () => <DeleteIcon />,
              tooltip: "Delete",
              onClick: (event, rowData) => {
                setProductDetails(rowData);
                handlerAccountDelete();
              },
            }),
          ]}
          options={{
            actionsColumnIndex: -1,
            headerStyle: {
              backgroundColor: Pal.palette.primary.main,
              color: "#fff",
              fontWeight: "bold",
            },
            exportButton: true,
            tableLayout: "auto",
          }}
          localization={{
            pagination: {
              labelRowsSelect: "Rows per page",
            },
          }}
        />
        <Snackbar
          open={open}
          anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={3000}
          onClose={handleCloseSnackBar}
          key={vertical + horizontal}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleCloseSnackBar}
            severity={snackBarstate.type}
          >
            {snackBarstate.message}
          </MuiAlert>
        </Snackbar>
      </Grid>

      {/* Edit Product Modal */}
      <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container
          component={Paper}
          style={{
            padding: "20px",
            maxWidth: "50vw",
            maxHeight: "80vh",
            overflow: "auto",
            scrollbarWidth: "2px",
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} align="center">
              <Typography variant="h5">Edit Product</Typography>
            </Grid>
            <form className={classes.form} noValidate style={{ padding: 20 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    autoFocus
                    margin="dense"
                    variant="outlined"
                    autoComplete="pName"
                    required
                    fullWidth
                    label="Name"
                    name="name"
                    value={productDetails.name}
                    onChange={handleProductDetails("name")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    multiline
                    rows={4}
                    label="Description"
                    value={productDetails.description}
                    onChange={handleProductDetails("description")}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Category"
                    style={{ marginTop: 8 }}
                    defaultValue={"DEFAULT"}
                    value={productDetails.category}
                    onChange={handleProductDetails("category")}
                  >
                    <MenuItem value="DEFAULT" disabled>
                      Choose a Product Category
                    </MenuItem>
                    {productCategories.map((el, index) => (
                      <MenuItem value={el.name} key={index}>
                        {el.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={6}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Sub Category"
                    style={{ marginTop: 8 }}
                    defaultValue={"DEFAULT"}
                    value={productDetails.subCategory}
                    onChange={handleProductDetails("subCategory")}
                  >
                    <MenuItem value="DEFAULT" disabled>
                      Choose sub-category
                    </MenuItem>
                    {productSubCategories.map((el, index) => (
                      <MenuItem value={el.name} key={index}>
                        {el.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Brand"
                    name="brand"
                    style={{ marginTop: 8 }}
                    value={productDetails.brand}
                    defaultValue="DEFAULT"
                    onChange={handleProductDetails("brand")}
                  >
                    <MenuItem value="DEFAULT" disabled>
                      Select Brand of Product
                    </MenuItem>
                    {productBrand.map((el, index) => (
                      <MenuItem value={el.name} key={index}>
                        {el.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    placeholder="dd/MM/YYYY"
                    label="Manufacture Date"
                    name="manufactureDate"
                    value={productDetails.manufactureDate}
                    onChange={handleProductDetails("manufactureDate")}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Category"
                    name="category"
                    style={{ marginTop: 8 }}
                    value={"DEFAULT"}
                    defaultValue={"DEFAULT"}
                    onChange={handlerColor("colors")}
                  >
                    <MenuItem value="DEFAULT" disabled>
                      Select Product Color
                    </MenuItem>
                    <MenuItem value="Red">Red</MenuItem>
                    <MenuItem value="Green">Green</MenuItem>
                    <MenuItem value="Black">Black</MenuItem>
                    <MenuItem value="Purple">Purple</MenuItem>
                  </Select>
                </Grid>

                {colors.length > 0 ? (
                  <Grid item xs={12}>
                    {colors.map((el, index) => (
                      <Chip
                        label={el}
                        key={index}
                        onDelete={handleDeleteColor(index)}
                        style={{
                          margin: "2px 4px",
                        }}
                      />
                    ))}
                  </Grid>
                ) : (
                  ""
                )}

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    name="stock"
                    label="Stock / Quantity"
                    value={productDetails.stockAvailable}
                    onChange={handleProductDetails("stockAvailable")}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    name="warranty"
                    label="Warranty"
                    value={productDetails.warranty}
                    onChange={handleProductDetails("warranty")}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Purchase Price"
                    value={productDetails.purchasePrice}
                    onChange={handleProductDetails("purchasePrice")}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Sale Price (Rs)"
                    name="salePrice"
                    value={productDetails.salePrice}
                    onChange={handleProductDetails("salePrice")}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Weight"
                    id="weight"
                    name="weight"
                    value={productDetails.weight}
                    onChange={handleProductDetails("weight")}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Select
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Product State"
                    name="state"
                    style={{ marginTop: 8 }}
                    defaultValue={"DEFAULT"}
                    value={productDetails.state}
                    onChange={handleProductDetails("state")}
                  >
                    <MenuItem value="DEFAULT">
                      Select the Product State
                    </MenuItem>
                    <MenuItem value="New">New</MenuItem>
                    <MenuItem value="Used">Used</MenuItem>
                    <MenuItem value="Refurbished">Refurbished</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Shipping Cost"
                    name="shippingCost"
                    value={productDetails.shippingCost}
                    onChange={handleProductDetails("shippingCost")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Dimensions"
                    placeholder="100in 100in 100in"
                    value={productDetails.dimensions}
                    onChange={handleProductDetails("dimensions")}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: 10,
                    marginRight: 10,
                    marginTop: 20,
                    marginBottom: 5,
                    padding: 20,
                    height: 120,
                    border: "1px solid #c4c4c4",
                    borderRadius: 6,
                  }}
                >
                  <Grid container justify="center" spacing={2}>
                    {productDetails.images.length > 0 ? (
                      productDetails.images.map((img, index) => (
                        <Grid item key={index} align="center">
                          <img
                            src={img}
                            alt="product-images"
                            width="60px"
                            height="60px"
                            style={{
                              border: "3px solid #e1e1e1",
                              padding: "2px",
                            }}
                          />
                          <div>
                            <HighlightOffRoundedIcon
                              onClick={() => handlerDeletePImage(index)}
                              style={{
                                color: "grey",
                              }}
                            />
                          </div>
                        </Grid>
                      ))
                    ) : (
                      <Typography>Upload Product Images</Typography>
                    )}
                  </Grid>
                </Grid>
                <Grid item style={{ marginBottom: 10, marginLeft: 10 }}>
                  <div>
                    <label htmlFor="contained-button-file">
                      <Button
                        size="small"
                        startIcon={<AddPhotoAlternateIcon />}
                        variant="outlined"
                        color="primary"
                        component="span"
                      >
                        Upload Images
                      </Button>
                    </label>
                    <input
                      id="contained-button-file"
                      type="file"
                      multiple
                      accept="image/png, image/jpeg"
                      onChange={fileHandler}
                      hidden
                    />
                  </div>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  style={{ marginLeft: 5, marginRight: 5 }}
                >
                  <Grid item xs={4}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        border: "1px solid #c4c4c4",
                        borderRadius: 4,
                        marginTop: 8,
                      }}
                    >
                      <FormControlLabel
                        margin="normal"
                        control={
                          <Switch
                            color="primary"
                            checked={productDetails.isOnSale}
                            onChange={HanderdiscountSwitch}
                          />
                        }
                        label="On Sale"
                        labelPlacement="start"
                      />
                    </div>
                  </Grid>

                  {productDetails.isOnSale ? (
                    <Grid item xs={8}>
                      <TextField
                        variant="outlined"
                        margin="dense"
                        required
                        fullWidth
                        label="Discount(%)"
                        id="discount"
                        name="discount"
                        value={productDetails.discountPercentage}
                        onChange={handlerDiscount("discountPercentage")}
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                </Grid>

                {/* SAVE CHANGES BUTTON */}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  align="center"
                  style={{ margin: "20px 0" }}
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: 10 }}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={editProductHandler}
                  >
                    Save Changes
                  </Button>
                </Grid>
              </Grid>

              <Snackbar
                open={open}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={3000}
                onClose={handleCloseSnackBar}
                key={vertical + horizontal}
              >
                <MuiAlert
                  elevation={6}
                  variant="filled"
                  onClose={handleCloseSnackBar}
                  severity={snackBarstate.type}
                >
                  {snackBarstate.message}
                </MuiAlert>
              </Snackbar>
            </form>
          </Grid>
        </Container>
      </Modal>

      {/* Import Products Modal */}
      <Modal
        open={ipmodalOpen}
        onClose={closeIPmodal}
        onBackdropClick={closeIPmodal}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container component={Paper} maxWidth="sm" style={{ padding: 20 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} align="center">
              <Typography variant="h5">Import Products using CSV</Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              <div>
                <label htmlFor="contained-button-file">
                  <Button variant="contained" color="primary" component="span">
                    Select File
                  </Button>
                </label>
                <CSVReader
                  inputId="contained-button-file"
                  onFileLoaded={handleFileLoaded}
                  parserOptions={papaparseOptions}
                  inputStyle={{ display: "none" }}
                />
              </div>
              <div>
                <Typography variant="subtitle2" color="primary">
                  {selectedFile}
                </Typography>
              </div>

              <div>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={progressValue === 0 ? true : false}
                  onClick={handeStartImport}
                >
                  Start Importing
                </Button>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} align="center">
              {!selectedFile ? (
                <div></div>
              ) : (
                <LinearProgress variant={progressCSV} value={progressValue} />
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              {selectedFile ? (
                <Typography variant="body1" align="center">
                  Products have been loaded. Click on Start Importing Button
                  now!
                </Typography>
              ) : (
                <Typography variant="body1"></Typography>
              )}
            </Grid>
          </Grid>
        </Container>
      </Modal>

      {/* Snackbar Alert */}
      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>

      {/* Delete Confirmation Dialog */}
      <DeleteProduct
        DeletingProduct={isDeletingProduct}
        setDeletingProduct={setIsDeletingProduct}
        confirmedDelete={confirmedDelete}
      />
    </Grid>
  );
}
